import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
// constants
import routes from '../../constants/routes';

// hooks
import useFromLocationState from '../../hooks/helper/useFromLocationState';
import { useAuthSession } from '../../hooks/useAuthSession';

// images
import Logo from '../../images/logos/logoOnly.svg?react';

import ForgotPasswordCard from './ForgotPasswordCard';
import InviteCard from './InviteCard';
// components
import LoginCard from './LoginCard';
import ResetCard from './ResetCard';

export default function LoginMain() {
    const prevLocation = useFromLocationState();
    const params = new URLSearchParams(window.location.search);
    let redirectUrl = params.get('redirect') ?? params.get('redirect_url');
    if (redirectUrl === null) {
        redirectUrl = prevLocation?.pathname;
    }

    const { user: currentUser } = useAuthSession();

    if (currentUser?.name) {
        return <Redirect to={redirectUrl} />;
    }

    return (
        <Container>
            <Section>
                <LogoHeader>
                    <StyledLogo />
                </LogoHeader>
                <Switch>
                    <Route path={routes.login} component={LoginCard} />
                    <Route path={routes.signup} component={InviteCard} />
                    <Route
                        path={routes.forgotPassword}
                        component={ForgotPasswordCard}
                    />
                    <Route path={routes.resetPassword} component={ResetCard} />
                    <Redirect to={routes.login} />
                </Switch>
            </Section>
        </Container>
    );
}

const Container = styled.div({
    width: '100%',
    height: '100%',
    maxHeight: '100vh',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    overflow: 'hidden',
    alignItems: 'center',
    backgroundColor: aampeTheme.colors.gray25,
});

const Section = styled.div({
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    overflow: 'none',
    zIndex: 1,
});

const LogoHeader = styled.div({
    //vertically align the logo in the center
    display: 'flex',
    alignItems: 'center',
    maxHeight: '80px',
    height: '10vh',
});
const StyledLogo = styled(Logo)({
    width: '80px',
    height: '10vh',
    maxHeight: '80px',
    marginTop: '10px',
});
